var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 107.254,
    height: 107.254,
    viewBox: "0 0 107.254 107.254",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Facebook",
    transform: "translate(40.681 40.681)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27163",
    "data-name": "Path 27163",
    d: "M53.627,0a53.627,53.627,0,1,0,53.627,53.627A53.628,53.628,0,0,0,53.627,0ZM69.375,32.533H61.925c-2.631,0-3.178,1.076-3.178,3.8V42.9H69.375L68.352,54.444h-9.6V88.913H44.983V54.588H37.823V42.9h7.161V33.7c0-8.634,4.618-13.145,14.86-13.145h9.531Z",
    transform: "translate(-40.681 -40.681)",
    fill: "#e7f0f4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/Facebook_icon.7b2a3bff054d0a85d985d6f222013328.svg";
export { ForwardRef as ReactComponent };